module.exports = __webpack_public_path__ + "img/57_27.2c53989b.png";